import { render, staticRenderFns } from "./CreateGiftCardModal.vue?vue&type=template&id=2f8785f4&"
import script from "./CreateGiftCardModal.vue?vue&type=script&lang=js&"
export * from "./CreateGiftCardModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateGiftCardModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports